export default "__VITE_ASSET__DsbumPV5__"